import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { DragAndDropDirective } from './profile/drag-and-drop.directive';
import { MaterialModule } from '../view-models/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HelpersModule } from '../helpers/helpers.module';

@NgModule({
  declarations: [
    ProfileComponent,
    NotificationsComponent,
    DragAndDropDirective
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HelpersModule
  ],
  exports: [
    DragAndDropDirective
  ]
})

export class SettingsModule { }
